export default {
  // 获取特定工具的历史记录
  getHistoryByTool: (state) => (toolName) => {
    return state.historyCache[toolName] || null;
  },

  // 获取特定工具的最新N条历史记录
  getLatestHistoryByTool:
    (state) =>
    (toolName, limit = 2) => {
      const history = state.historyCache[toolName];
      if (!history || !Array.isArray(history)) {
        return [];
      }
      return history.slice(0, limit);
    },

  // 检查特定工具是否有缓存
  hasHistoryCache: (state) => (toolName) => {
    return !!state.historyCache[toolName];
  },
};
